import React from "react";
import Webcam from "react-webcam";
import { Col, Image, Stack } from "react-bootstrap";
import { Container } from "react-bootstrap";
import { useState } from "react";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { setProblemPhotoBase64, resetProblemPhotoBase64, setProblemVideo } from "../anomalyRegistration/anomalySlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";


export function ScreenShot(props) {
    const [capturing, setCapturing] = useState(false)
    const [recordedChunks, setRecordedChunks] = React.useState([]);
    const mediaRecorderRef = React.useRef(null);
    const [isRotate, setIsRotate] = useState(false)
    const [navigateAnomaly, setNavigateAnomaly] = useState(false)
    const login = useSelector((state) => state.login)
    var facingMode = { exact: "environment" }
    const dispatch = useDispatch()

    let navigate = useNavigate();
    useEffect(() => {
        if (!login.token) {
            return navigate("/login");
        }
    })
    useEffect(() => {
        if (navigateAnomaly) {
            return navigate("/anomaly");
        }
    })
    const webcamRef = React.useRef(null);
    if (isRotate) {
        facingMode =  "user"
    }
    const videoConstraints = {
        width: 720,
        height: 720,
        facingMode: facingMode
    };

    function onRotateCamera() {
        if (isRotate) {
            setIsRotate(false)
        }
        else {
            setIsRotate(true)
        }
    }
    function makePhoto() {
        //setImageSrc(webcamRef.current.getScreenshot())
        setNavigateAnomaly(true)
        dispatch(setProblemPhotoBase64(webcamRef.current.getScreenshot()))
    }

    const handleStartCaptureClick = React.useCallback(() => {
        setCapturing(true);
        mediaRecorderRef.current = new MediaRecorder(webcamRef.current.stream, {
          mimeType: "video/mp4"
        });
        mediaRecorderRef.current.addEventListener(
          "dataavailable",
          handleDataAvailable
        );
        mediaRecorderRef.current.start();
      }, [webcamRef, setCapturing, mediaRecorderRef]);
    
      const handleDataAvailable = React.useCallback(
        ({ data }) => {
          if (data.size > 0) {
            setRecordedChunks((prev) => prev.concat(data));
          }
        },
        [setRecordedChunks]
      );
    
    const handleStopCaptureClick = React.useCallback(() => {
        mediaRecorderRef.current.stop();

        setCapturing(false);
    }, [mediaRecorderRef, webcamRef, setCapturing]);

    const handleDownload = React.useCallback(() => {
        if (recordedChunks.length) {
            const blob = new Blob(recordedChunks, {
                type: "video/webm"
            });
            var reader = new FileReader();
            reader.readAsDataURL(blob); 
            reader.onloadend = function() {
                var base64data = reader.result;   
                // console.log(222, base64data)
                setNavigateAnomaly(true)
                dispatch(setProblemVideo(base64data))
            }
        //   const url = URL.createObjectURL(blob);
        //   const a = document.createElement("a");
        //   document.body.appendChild(a);
        //   a.style = "display: none";
        //   a.href = url;
        //   a.download = "react-webcam-stream-capture.webm";
        //   a.click();
        //   window.URL.revokeObjectURL(url);
        //   setRecordedChunks([]);
            // setNavigateAnomaly(true)
            // dispatch(setProblemVideo(recordedChunks))
        }
    }, [recordedChunks]);

    return (
        <Stack gap={3} className="col-md-6 mx-auto">
            <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                videoConstraints={videoConstraints}
            />
            <Button variant="primary" onClick={() => makePhoto()} className="me-10 ColorBlue" >Сделать фото </Button>
            <div className="row row-cols-2">
                <Col className="text-nowrap" >
                    <Stack gap={3}>
                        <Button variant="outline-secondary" onClick={() => handleStartCaptureClick()} className="me-10 ColorGray" disabled={capturing} >Записать видео</Button>
                    </Stack>
                </Col>

                <Col className="text-nowrap" >
                    <Stack gap={3}>
                        <Button variant="outline-secondary" onClick={() => handleStopCaptureClick()} className="me-10 ColorGray" disabled={!capturing}>Стоп</Button>
                    </Stack>
                </Col>
            </div>
            <Button variant="outline-secondary" onClick={handleDownload} className="me-10 ColorGray" disabled={recordedChunks.length == 0 || capturing}>Прикрепить видео</Button>
            <Button variant="outline-secondary" onClick={() => onRotateCamera()} className="me-10 ColorGray" >Изменить камеру </Button>
            <Button variant="outline-secondary" onClick={() => setNavigateAnomaly(true)} className="me-10 ColorGray" >Вернуться к регистрации аномалии </Button>
        </Stack>
    );
};
